// @flow
import type {
  OrdersOperation,
} from '../types'

export default ({
  operations: [],
}: {
  operations: Array<OrdersOperation>,
})
